import React , {useState, useEffect, useContext} from 'react'
import './HeaderV2.css';
import {Link, NavLink, useLocation} from 'react-router-dom';
import { user } from '../../libs/utils/user';
import { Badge, Icon, notification } from 'antd';
import { get } from '../../libs/utils/request';
import  Notifications  from '../Notifications/Notifications';
import AuthContext from '../../../store/AuthContext'
import UserContext  from '../../../store/UserContext';

interface Props {
    hamburgerMenuIsOpen: boolean;
    onOpen: (hamburgerMenuIsOpen: boolean) => void;
    notification: (param: boolean) => void;
    notificationParam: boolean
}

export default function HeaderV2({hamburgerMenuIsOpen, onOpen, notification, notificationParam}:Props) {
    const [messageCount, setMessageCount] = useState(0)
    const [notifications, setNotifications] = useState([])
    const [notificationCount, setNotificationCount] = useState(0);
    const [noGroups, setNoGroups] = useState(false)
    const authContext = useContext(AuthContext);
    const userCtx = useContext(UserContext)
    const location = useLocation()

    let timer:any = null

    const isActive = userCtx.user && userCtx.user.active;

    useEffect(()=> {
        onOpen(false)
    },[location])
   
    

    useEffect(() => {
        loader();
        (process.env.REACT_APP_HOST_ENV === 'live' 
        || process.env.REACT_APP_HOST_ENV === 'demo' //testing notifications and messageCount on demo
        )
         && startTimer();
      }, []);
      

    const loader = async ()  => {
        if(user()?.active || user()?.trial)
            try {
                 await get('/ping').then((res:any)=> {
                     setNotifications(res.result);
                     setNotificationCount(res.notificationCount);
                     setMessageCount(res.messageCount);
                    
                });
              } catch (e) {
                console.error(e);
              }
        };
    const startTimer = () => {
        if (timer !== null) {
          clearInterval(timer);
        }
        timer = setInterval(() => {
        loader();
        }, 15000);
      }

      let trialEnded = false;
    
      if(window.location.href.includes('trial-ended')){
          trialEnded = true;
      }
    
    
    
    return (
        
        <>
        <div className='header-navbar-container'>
            <div className='navbar'>
               <div className='nav-links'>
                   <NavLink className="main-logo" to={trialEnded ? '/trial-ended' : "/"}>
                     <img src="/images/bmeus_index_page/logo.png"/>
                   </NavLink>
                   {
                       isActive &&  <NavLink
                       to='/dashboard'
                       className='Header-navlink'
                       activeClassName='Header-navlink-selected'
                        >
                       Dashboard
                        </NavLink>

                   }
                    <NavLink
                     to={trialEnded ? '/trial-ended':'/ideas'}
                     className='Header-navlink'
                     activeClassName='Header-navlink-selected'
                     >
                     Ideas
                    </NavLink>
                  
                    <NavLink
                        to={trialEnded ? '/trial-ended' : '/startups'}
                        className='Header-navlink'
                        activeClassName='Header-navlink-selected'
                    >
                    Startups
                    </NavLink>
                    <NavLink
                        to={window.location.pathname}
                        className='Header-navlink  Header-navlink-disabled'
                        activeClassName='Header-navlink-selected'
                    >
                    Startup Studio
                    </NavLink>
                    <NavLink
                        to={window.location.pathname}
                        className='Header-navlink  Header-navlink-disabled'
                        activeClassName='Header-navlink-selected'
                    >
                    Spinoff
                    </NavLink>
                    <NavLink
                        to={window.location.pathname}
                        className='Header-navlink  Header-navlink-disabled'
                        activeClassName='Header-navlink-selected'
                    >
                    R&D
                    </NavLink>
                    <NavLink
                        to={trialEnded ? '/trial-ended' : '/events'}
                        className='Header-navlink'
                        activeClassName='Header-navlink-selected'
                    >
                    Events
                    </NavLink>
                    <NavLink
                        to={trialEnded ? '/trial-ended' : '/blog'}
                        className='Header-navlink'
                        activeClassName='Header-navlink-selected'
                    >
                    Blog
                    </NavLink>
                    <NavLink
                        to={trialEnded ? '/trial-ended' : '/organizations/bmeus3'}
                        className='Header-navlink'
                        activeClassName='Header-navlink-selected'
                        aria-disabled = {true}
                    >
                    About U[S]3
                    </NavLink>
                    <a
                    target='_blank'
                    href='https://us3.bme.hu'
                    className='Header-navlink'
                    >
                    Go to us3.bme.hu
                    </a>
                    {
                        isActive && noGroups &&
                        <NavLink
                        to='/groups'
                        className='Header-navlink'
                        activeClassName='Header-navlink-selected'
                        >
                        Groups
                        </NavLink>
                    }
                   
                
                </div>
                {
                    userCtx.user ? (
                        <div className='header-user-info'>
                            <div className='header-token'>
                                <img src="/images/token.svg" alt='' className='header-token-img'/>
                                <div>0.0</div>
                            </div>
                            <div className='header-alerts'>
                                <NavLink to="/messages">
                                    <div className='header-notification'>
                                        <Badge count={messageCount} style={{ fontSize: '12px', backgroundColor: 'rgb(226,49,92)' }}>
                                            <div style={{ marginRight: '5px' }}> 
                                                <img src="/images/header-message.svg" alt=''/>
                                            </div>
                                        </Badge>
                                    </div>
                                </NavLink>
                                <Notifications notifications={notifications} notificationCount={notificationCount}/>
                            </div>
                        <div className='Header-user' key='user'>
                                
                                <Link
                                to='/profile'
                                className='header-user-name'
                                >
                                    <img src={userCtx.user.profileImage || '/images/user.svg'} alt='' />
                                <p className='hey'>Hey <span>{userCtx.user.firstName}!</span> </p>
                                </Link>
                        </div>
                        <div  className='logout'>
                            <Icon  className='logout-icon' onClick={()=> authContext.logout()}  type='logout' />
                        </div>
                </div>
                    ):(
                        <NavLink to="/login">
                            <div className='Login-route'>Log in</div>
                        </NavLink>
                    )
                }

                <div className='hamburger-menu' onClick={()=> onOpen(true)}>
                        <img src="/images/hamburger-menu.svg"/>
                </div>
            </div>
            <div className={hamburgerMenuIsOpen ? "side-bar" : "side-bar-inactive"}>
                <div className='side-bar-container'>
                    <div className='sidebar-content'>
                        <div className='close-sidebar' onClick={()=> onOpen(false)}>
                            <img className='close-icon' src="/images/close_black.svg"/>
                        </div>
                        {
                        userCtx.user &&
                        <div className='sidebar-user-links'>
                            <div className='Header-user' key='user'>
                                    <div className='sidebar-profile'>
                                        <Link
                                        to='/profile'
                                        className='sidebar-user-name'
                                        >
                                            <div className='username-container'>
                                            <img className='sidebar-profile-pic' src={userCtx.user.profileImage || '/images/user.svg'} alt='' />

                                                <div>Hey</div>
                                                <div className='my-user-firstname'>{userCtx.user.firstName}</div>
                                            </div>
                                        </Link>
                                    </div>
                            </div>
                            <a href='/messages' className='sidebar-notification'>
                                <NavLink to="/messages">
                                        <Badge count={messageCount} style={{ fontSize: '12px', backgroundColor: 'rgb(226,49,92)' }}>
                                            <img  className='sidebar-icons' src="/images/header-message.svg" alt=''/>
                                        </Badge>
                                </NavLink>
                                <div className='sidebar-text'>Messages</div>
                            </a>
                            <div className='sidebar-message' onClick={()=> notification(!notificationParam) }>
                                <Notifications  type="white" notifications={notifications} notificationCount={notificationCount}/>
                            </div>
                            <div className='sidebar-token'>
                                <img className='sidebar-icons' src="/images/token.svg"/>
                                <div className='sidebar-text'>0.0 tokens</div>
                            </div>
                        </div>
                    }
                        
                        <div className='side-route-links'>
                            {
                                isActive &&
                                <NavLink
                                to='/dashboard'
                                className='sidebar-navlink'
                                activeClassName='sidebar-navlink-selected'
                            >
                                Dashboard
                            </NavLink>

                            }
                          
                        <NavLink
                            to={trialEnded ? '/trial-ended':'/ideas'}
                            className='sidebar-navlink'
                            activeClassName='Header-navlink-selected'
                            >
                            Ideas
                        </NavLink>
                  
                        <NavLink
                            to={trialEnded ? '/trial-ended' : '/startups'}
                            className='sidebar-navlink'
                            activeClassName='Header-navlink-selected'
                        >
                            Startups
                        </NavLink>
                        <NavLink
                            to={window.location.pathname}
                            className='sidebar-navlink  sidebar-navlink-disabled'
                            activeClassName='Header-navlink-selected'
                        >
                            Startup Studio
                        </NavLink>
                        <NavLink
                            to={window.location.pathname}
                            className='sidebar-navlink  sidebar-navlink-disabled'
                            activeClassName='Header-navlink-selected'
                        >
                            Spinoff
                        </NavLink>
                        <NavLink
                            to={window.location.pathname}
                            className='sidebar-navlink  sidebar-navlink-disabled'
                            activeClassName='Header-navlink-selected'
                        >
                            R&D
                        </NavLink>
                        <NavLink
                            to={trialEnded ? '/trial-ended' : '/events'}
                            className='sidebar-navlink'
                            activeClassName='Header-navlink-selected'
                        >
                            Events
                        </NavLink>
                        <NavLink
                            to={trialEnded ? '/trial-ended' : '/blog'}
                            className='sidebar-navlink'
                            activeClassName='Header-navlink-selected'
                        >
                            Blog
                        </NavLink>
                        <NavLink
                            to={trialEnded ? '/trial-ended' : '/organizations/bmeus3'}
                            className='sidebar-navlink'
                            activeClassName='Header-navlink-selected'
                            aria-disabled = {true}
                        >
                            About U[S]3
                        </NavLink>
                        <a
                            target='_blank'
                            href='https://us3.bme.hu'
                            className='sidebar-navlink'
                        >
                            Go to us3.bme.hu
                        </a>
                           
                            {
                               userCtx.user ? 
                                ( 
                                <div className='sidebar-logout' aria-hidden='true' onClick={() => authContext.logout()}>
                                <Icon className='sidebar-logout' type='logout' />
                                <span>Logout</span>
                                 </div>
                                 )
                                :
                                (
                                 <NavLink to="/login">
                                     <div className='sidebar-login'>Log in</div>
                                 </NavLink>
                                )
                            }
                           
                        </div>
                </div>
                </div>
            </div>
        </div>
       
        </>
    )
}
